var ToolbarBuilder = /** @class */ (function () {
    function ToolbarBuilder(update) {
        if (typeof update !== 'undefined' && update) {
            this._toolbarConfig = {};
            return;
        }
        this._toolbarConfig = {
            displayNavigationTitle: false,
            buttons: {
                search: false,
                return: false,
                help: true
            },
            eventButtons: []
        };
    }
    ToolbarBuilder.prototype.navigationTitle = function (active) {
        this._toolbarConfig.displayNavigationTitle = typeof active !== 'undefined' ? active : true;
        return this;
    };
    ToolbarBuilder.prototype.searchButton = function (active) {
        this._toolbarConfig.buttons.return = typeof active !== 'undefined' ? active : true;
        return this;
    };
    ToolbarBuilder.prototype.returnButton = function (active) {
        this._toolbarConfig.buttons.return = typeof active !== 'undefined' ? active : true;
        return this;
    };
    ToolbarBuilder.prototype.helpButton = function (active) {
        this._toolbarConfig.buttons.help = typeof active !== 'undefined' ? active : true;
        return this;
    };
    ToolbarBuilder.prototype.addEventButton = function (button) {
        if (button.name && button.icon && button.callback) {
            this._toolbarConfig.eventButtons.push(button);
        }
        else {
            throw new Error('A configuração do botão precisa contar com o nome, o ícone e o callback. (name, icon, callback)');
        }
        return this;
    };
    ToolbarBuilder.prototype.build = function () {
        return this._toolbarConfig;
    };
    return ToolbarBuilder;
}());
export { ToolbarBuilder };
